/// <reference lib="WebWorker" />
import type { PrecacheEntry, SerwistGlobalConfig } from 'serwist';
import { Serwist } from 'serwist';

import { runtimeCaching } from './runtime-caching';

declare global {
  interface WorkerGlobalScope extends SerwistGlobalConfig {
    // Change this attribute's name to your `injectionPoint`.
    // `injectionPoint` is an InjectManifest option.
    // See https://serwist.pages.dev/docs/build/configuring
    __SW_MANIFEST: (PrecacheEntry | string)[] | undefined;
  }
}

declare const self: ServiceWorkerGlobalScope;

const serwist = new Serwist({
  precacheEntries: self.__SW_MANIFEST,
  skipWaiting: true,
  clientsClaim: true,
  navigationPreload: true,
  disableDevLogs: true,
  runtimeCaching,
  fallbacks: {
    entries: [
      {
        url: '/~offline',
        matcher({ request }) {
          return request.destination === 'document';
        },
      },
    ],
  },
});

self.addEventListener('push', (event) => {
  try {
    if (event.data) {
      const data = event.data.json();
      const {
        data: { image, channel, time, url },
      } = data;
      const timeDate = new Date(time * 1000).toISOString();

      const trackingUrl = new URL(url);
      trackingUrl.searchParams.append('at_medium', 'push');
      trackingUrl.searchParams.append('at_campaign', 'ZDFHeute');
      trackingUrl.searchParams.append('at_push_channel', channel);
      trackingUrl.searchParams.append('at_notification_title', data.title);
      trackingUrl.searchParams.append('at_notification_text', data.body);
      trackingUrl.searchParams.append('at_push_time', timeDate);

      event.waitUntil(
        self.registration.showNotification(data.title, {
          // ZDFheute icon as a base64 encoded string because we can't use assets in the service worker
          icon: 'data:image/png;base64,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',
          image,
          body: data.body,
          data: {
            url: trackingUrl.toString(),
          },
        } as NotificationOptions),
      );
    }
  } catch (_e) {
    return;
  }
});

self.addEventListener('notificationclick', (event) => {
  const { notification } = event;
  notification.close();
  if (notification.data?.url) {
    event.waitUntil(self.clients.openWindow(notification.data.url));
  }
});

serwist.addEventListeners();
